import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import * as components from './components/documentation/formats';

Vue.config.productionTip = false;

// for (const componentName in components) {
//   const component = components[componentName];
//   Vue.component(component.name, component);
// }

Object.keys(components).forEach((componentName) => {
  Vue.component(components[componentName].name, components[componentName]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
